export default {
	data() {
		return {
			showIdcard2:false,
			showIdcardDown:false,
			idcards:'',
			idcards2:'',
			idList:[],
			

		}
	},
	methods: {
		// 显示根据身份证批量生成学生证明弹窗
		showIdcardDialog() {
		    this.showIdcard2 = true;
		},
		// 身份证批量下载学士证明
		showIdcardDownDialog() {
		    this.showIdcardDown = true;
		},
		// 取消批量生成证明
		colseGenerateProve2() {
		    this.showIdcard2 = false;
		    this.idcards2 = [];
		},
		// 批量生成学生证明
		generateProve2() {
		    // this.showIdcard = false
		    if (this.idcards2.trim() === '') {
		        this.$message({
		            type: 'error',
		            message: '最少输入一个身份证号'
		        })
		        return
		    }
		    let idcard_arr = this.idcards2.trim().split('\n')
		
		    // 根据身份证号获取id
		    this.getIdByIdcard2(idcard_arr);
		},
		// 根据身份证号数组获取id数组
		getIdByIdcard2(idcard_arr) {
		    this.$post('users/idcard_arr_id', {
		        token: this.$store.state.authority_management,
		        offset: 0,
		        length: 9999,
		        idcard_arr: JSON.stringify(idcard_arr),
		        shop_id: this.$store.state.store.id
		    }).then(res => {
		        // console.log(res)
		        if (res.data.result.total !== idcard_arr.length) {
		            this.$message({
		                type: 'error',
		                message: '您输入的身份证信息有误, 请重新输入'
		            })
		            return
		        }
		        let list = res.data.result.data
		        list.map(i => {
		            this.idList.push(i.id * 1)
		        });
		
		        // 生成证书
		        this.createCers(this.idList);
		        this.idcards2 = [];
		    })
		},
		//生成学时证明
		createCers(userIdList) {
		
		    // 查询用户state==2的订单
		    this.$post('orders/paid_order2', {
		        token: this.$store.state.authority_management,
		        owner_ids: JSON.stringify(userIdList),
		        offset: 0,
		        length: 999
		    }).then(res => {
		        // 得到订单数组
		        let orderList = res.data.result.data;
		
		        // 查询category_order表中对应的记录
		        this.$post('category_order/get_by_orders', {
		            token: this.$store.state.authority_management,
		            order_ids: JSON.stringify(orderList),
		            offset: 0,
		            length: 999
		        }).then(res2 => {
		            // 得到未生成证书的记录
		            let nullCerList = res2.data.result.data;
		
		            // 循环生成证书，并将记录修改为已生成证书
		            for (let item of nullCerList) {
		
		                // 创建证书
		                this.$post('cers/shop_create', {
		                    token: this.$store.state.authority_management,
		                    category_ids: JSON.stringify([item.category_id]),
		                    cer_year: item.category_year,
		                    pay_date: item.study_start_time,
		                    end_date: item.study_end_time,
		                    owner_id: item.user_id
		                }).then(res3 => {
		
		                    if (res3.data.status === 'success') {
		                        // 将对应的记录修改为已生成证书
		                        this.$post('category_order/update', {
		                            id: item.id,
		                            is_first: 1,
		                            score: 100,
		                            category_progress: 1
		                        });
		                    }
		                });
		            }
		        });
		    }).then(() => {
		        this.$message.success('批量生成学时证明成功');
		        this.showIdcard2 = false;
		        // this.getAllStudent();
		    }).catch((error) => {
		        console.log(error);
		        this.$message.error('批量生成学时证明失败，请稍后重试！');
		    });
		},
		
		// 身份证批量下载取消按钮
		colseGenerateProve() {
		    this.showIdcard = false;
		    this.idcards = "";
		},
		// 身份证批量下载学生证明
		generateProveData() {
		    // this.showIdcard = false
		    if (this.idcards.trim() === "") {
		        this.$message({
		            type: "error",
		            message: "最少输入一个身份证号"
		        });
		        return;
		    }
		    let idcard_arr = this.idcards.trim().split("\n");
		
		    this.$post("purchased/get_image", {
		        idcard_arr: JSON.stringify(idcard_arr),
		        token: this.$store.state.authority_management
		    }).then(res => {
		        this.showIdcardDown = false;
		        var alink = document.createElement("a");
		        // let downImage = 'https://zzrc.bayou-tech.cn/' + res.data.result;
		        let downImage = this.baseUrl + res.data.result;
		        alink.href = downImage;
		        alink.click();
		    });
		
		    // 检查输入的身份证是否有误
		    // for (let i = 0; i < idcard_arr.length; i++) {
		    //   this.getUserByIdcard(idcard_arr[i])
		    //   if (this.flag === 0) {
		    //     break
		    //   }
		    // }
		
		    // 根据身份证号获取id
		    // this.getIdByIdcard(idcard_arr)
		},
	},
	created() {
		
	}

}
